cb.define([], function() {
	var AA_aa_wechatsetting_VM_extend = {

		doAction: function(name, viewmodel) {
			if(this[name]) {
				this[name](viewmodel);
			}
		},
		init: function(viewmodel) {
			//微信配置说明所在的文本框
			viewmodel.addProperty('instructions', new cb.models.SimpleModel());
			viewmodel.get("instructions").setReadOnly(true);
			
			var mode = viewmodel.getParams().mode;
			if(mode == 'browse') {
				viewmodel.get("certpwd").setVisible(false);
				viewmodel.get("instructions").setReadOnly(true);
			} else {
				viewmodel.get("certpwd").setVisible(true);
				viewmodel.get("instructions").setReadOnly(true);
			}
			viewmodel.on("modeChange", function(data) {
				if(data == 'browse') {
					viewmodel.get("certpwd").setVisible(false);
					viewmodel.get("instructions").setReadOnly(true);
				} else {
					viewmodel.get("certpwd").setVisible(true);
					viewmodel.get("instructions").setReadOnly(true);
				}
			});
			
			viewmodel.on("afterLoadData", function(data) {
				var paymenttypevalue = viewmodel.get("paymenttype").getValue();
				if(paymenttypevalue == 0) {//普通模式
					viewmodel.get("subappid").setVisible(false);
					viewmodel.get("submchid").setVisible(false);
					
					var instructions = '在进行微信参数设置前，请先确保有微信支付能力。详情可登录微信官方网站，进入各支付场景的接入指南页面，进行申请。详细接入步骤可查看接入指南页面右下角的“了解详情流程”。https://pay.weixin.qq.com/guide/index.shtml 普通模式：微信支付审核通过后，您将收到一封邮件，邮件中包含了商户的MCHID、APPID及密码等开发者信息。';
					viewmodel.get("instructions").setValue(instructions);
					viewmodel.get("instructions").setReadOnly(true);
					
				} else if(paymenttypevalue == 1) {//服务商模式
					viewmodel.get("subappid").setVisible(true);
					viewmodel.get("submchid").setVisible(true);
					
					var instructions = '在进行微信参数设置前，请先确保有微信支付能力。详情可登录微信官方网站，进入各支付场景的接入指南页面，进行申请。详细接入步骤可查看接入指南页面右下角的“了解详情流程”。https://pay.weixin.qq.com/guide/index.shtml 服务商模式：微信支付审核通过后，您将收到一封邮件，邮件中包含了商户的MCHID、APPID及密码等开发者信息，对应服务商模式输入项sub_mch_id及sub_app_id。页面中的APPID和mch_id以及证书密码可咨询服务商。';
					viewmodel.get("instructions").setValue(instructions);
					viewmodel.get("instructions").setReadOnly(true);
				}
			});
			viewmodel.on('afterEdit', function (mode){
				viewmodel.get("instructions").setReadOnly(true);
			})
			
			viewmodel.get('paymenttype').on('afterValueChange', function(data) {
				if(data.value.value == 0) {
					viewmodel.get("subappid").setVisible(false);
					viewmodel.get("submchid").setVisible(false);
					
					var instructions = '在进行微信参数设置前，请先确保有微信支付能力。详情可登录微信官方网站，进入各支付场景的接入指南页面，进行申请。详细接入步骤可查看接入指南页面右下角的“了解详情流程”。https://pay.weixin.qq.com/guide/index.shtml 普通模式：微信支付审核通过后，您将收到一封邮件，邮件中包含了商户的MCHID、APPID及密码等开发者信息。';
					viewmodel.get("instructions").setValue(instructions);
					
				} else if(data.value.value == 1) {
					viewmodel.get("subappid").setVisible(true);
					viewmodel.get("submchid").setVisible(true);
					
					var instructions = '在进行微信参数设置前，请先确保有微信支付能力。详情可登录微信官方网站，进入各支付场景的接入指南页面，进行申请。详细接入步骤可查看接入指南页面右下角的“了解详情流程”。https://pay.weixin.qq.com/guide/index.shtml 服务商模式：微信支付审核通过后，您将收到一封邮件，邮件中包含了商户的MCHID、APPID及密码等开发者信息，对应服务商模式输入项sub_mch_id及sub_app_id。页面中的APPID和mch_id以及证书密码可咨询服务商。';
					viewmodel.get("instructions").setValue(instructions);
				}
			});
			
			var storesModel = viewmodel.get("suitableStoreOfWeChat");
			if(storesModel) {
				storesModel.on('beforeBrowse', function(data) {
					if(data) {
						switch(data.cellName) {
							case "store_name":
							debugger
								//当前页面已选择的门店不再在参照面板中出现
								var rows = storesModel.getRows();
								var storeids = [];
								rows.forEach(function(item, index) {
									if(data.rowIndex === index) return;
									if(item.store_name === undefined) return;
									storeids.push(item.store);
								})
								var condition = {
									"isExtend": true,
									simpleVOs: []
								};
								if(storeids) {
									condition.simpleVOs.push({
										field: 'id',
										op: 'nin',
										value1: storeids
									});
								}
								data.context.setFilter(condition);
								break;
						}
					}
				});
			}
		}
	}
	try {
		module.exports = AA_aa_wechatsetting_VM_extend;
	} catch(error) {

	}
	return AA_aa_wechatsetting_VM_extend;
});


// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_wechatsetting_VM.Extend.js